import * as React from 'react'
import {ReactNode} from 'react'
import {
    BlockSpacer,
    currentMedia,
    GridContainer,
    GridItem
} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {DisplayItemLabelDiv} from '../../../../../styledComponents/DisplayItem'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import {FileInformation} from '../../../../../components/applications/ResidentAttachmentFileArea'
import {
    getFormattedAddress,
    getFormattedDate
} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents';

interface Props {
    applicantFamilyName: string
    applicantFirstName: string
    constructionContentDetail: string
    constructionStartDate: string
    constructionEndDate: string
    contractorName: string
    contractorZipCode: string
    contractorPrefecture: string
    contractorAddress2: string
    contractorAddress3: string
    contractorBuildingRoomNumber: string
    contractorPhoneNumber: string
    contractorRep: string
    applyToAttachment: FileInformation[]
    applyFlag?: boolean
}

const NatResidentConstructionConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName,
        applicantFirstName,
        constructionContentDetail,
        constructionStartDate,
        constructionEndDate,
        contractorName,
        contractorZipCode,
        contractorPrefecture,
        contractorAddress2,
        contractorAddress3,
        contractorBuildingRoomNumber,
        contractorPhoneNumber,
        contractorRep,
        applyToAttachment
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.CONSTRUCTION_APPLY.label
    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )
    const constructionStartDateLabel = (constructionStartDate) ?
        getFormattedDate(constructionStartDate) : ''
    const constructionEndDateLabel = (constructionEndDate) ?
        getFormattedDate(constructionEndDate) : ''

    const contractorInfo = (): ReactNode => {
        const items = []
        items.push(`業者名：${contractorName}`)
        items.push(`住所：${getFormattedAddress(
            contractorZipCode,
            contractorPrefecture,
            contractorAddress2,
            contractorAddress3,
            contractorBuildingRoomNumber)}`
        )
        items.push(`電話番号：${contractorPhoneNumber}`)
        items.push(`担当者：${contractorRep}`)

        return <>
            <NatResidentApplicationDetailConfirmItem
                title={'工事施工者'}
                items={items}
            />
        </>
    }

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'工事内容'}
            items={[constructionContentDetail]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'工事期間'}
            items={[`開始日：${constructionStartDateLabel}`, `終了日：${constructionEndDateLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        {contractorInfo()}
        <BlockSpacer height={'5px'}/>
        <ItemDiv>
            <GridContainer>
                <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>添付資料</Box></DisplayItemLabelDiv>
                </GridItem>
                <GridItem over={9}>
                    {(applyToAttachment && applyToAttachment.map((attachmentFile, index) => (
                        <TextContents key={index}>
                            {attachmentFile.fileName}
                        </TextContents>
                    )))}
                </GridItem>
            </GridContainer>
        </ItemDiv>
        {applyFlag === false &&
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer alignItems={'flex-start'}>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>承認条件</Box> </DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            <RowFlexContainer>
                                <Box whiteSpace={'pre-wrap'}>
                                    一 工事等の施工内容は、工事申請書記載のとおりとすること<br/>
                                    二 工事等に要する費用は、全て申請者の負担とすること<br/>
                                    三 工事等のために共用部分を毀損し、又は他の組合員等に迷惑をかけたときは、申請者の責任において復旧又は補償を行うこと<br/>
                                    四 工事申請書に所有者承諾書・近隣承諾書が添付されている場合は、申請者はこの付記条件を遵守すること<br/>
                                    五 管理組合は、前各号の規定に反すると認めたときは、承認を取り消し、必要な処置を講ずる場合があること
                                </Box>
                            </RowFlexContainer>
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </>
        }
    </>)
}

NatResidentConstructionConfirm.displayName = 'NatResidentConstructionConfirm'
export default NatResidentConstructionConfirm

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
 ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`
const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
`